import React from "react";
import { SVG, IconProps } from "../SVG";

export const FunctionalCheckCircle2 = ({
    color = "currentColor",
    fill = "none",
    strokeWidth = "2",
    ...props
}: IconProps) => (
    <SVG
        xmlns="http://www.w3.org/2000/svg"
        fill={fill}
        viewBox="0 0 24 24"
        stroke={color}
        strokeWidth={strokeWidth}
        {...props}
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m16 9-5.5 5.5L8 12m14 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
        />
    </SVG>
);
FunctionalCheckCircle2.displayName = "FunctionalCheckCircle2";
